import { render, staticRenderFns } from "./ArrowCollapse.vue?vue&type=template&id=3560e117"
import script from "./ArrowCollapse.vue?vue&type=script&lang=js"
export * from "./ArrowCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports